import { render } from "./App.vue?vue&type=template&id=e5440692"
const script = {}

import "./App.vue?vue&type=style&index=0&id=e5440692&lang=scss"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__